import React, { useEffect, useRef } from "react";
import config from "../data/config";

const isDisplayMoreOption = process.env.REACT_APP_DISPLAY_MORE_BUTTON_ON_TOP_THUMB_BAR === 'true';

const TopThumbs = ({
  storyChangeHandler,
  currStoryId,
  categoryListData,
  setShowAllStoriesScreen,
  pauseSlideOnTap,
  callGaHandler,
}) => {
  const thumbRefs = useRef([]);

  useEffect(() => {
    // Scroll the active story into view when currStoryId changes
    const activeThumb = thumbRefs.current.find(
      (thumb) => thumb && Number(thumb.dataset.categoryId) === Number(currStoryId)
    );
    if (activeThumb) {
      activeThumb.scrollIntoView({ behavior: "smooth", inline: "center" });
    }
  }, [currStoryId]);

  const onViewAllClick = () => {
    pauseSlideOnTap(false, 'pause');
    setShowAllStoriesScreen(() => true);
    callGaHandler('View_all_stories', 'Open');
  }

  return (
    <>
      <button className="one3d-view-all-story-button" onClick={onViewAllClick}>
        <span>View All</span>
      </button>
      <div className="stories-thumb-wrapper one3d-stories-thumb-wrapper-new">
        <div className="one3d-stories-thumb-wrapper-inner">
          {categoryListData &&
            categoryListData.map((item, index) => {
              return (
                <div
                  ref={(el) => (thumbRefs.current[index] = el)}
                  data-category-id={item.category_id}
                  className={`stories-thumb ${
                    Number(currStoryId) === item.category_id ? "active" : ""
                  } ${!isDisplayMoreOption && index === categoryListData.length - 1 ? "d-none" : ""}`}
                  onClick={() => storyChangeHandler(index + 1)}
                  key={index}
                >
                  <img
                    src={`${config.BUCKET_URL}${item?.thumbnail_relative_path}`}
                    alt=""
                    className="thumb-img"
                  />
                  <div className="thumb-overlay"></div>
                  <div className="thumb-text">
                    <span>{item.category_name}</span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default TopThumbs;
